import { useTranslation } from 'react-i18next';
import Button from '../../../../../../../common/widgets/Button';
import Dialog from '../../../../../../../common/widgets/Dialog';
import TextArea from '../../../../../../../common/widgets/TextArea';
import { CodeModel } from '../../../../../models/codes';
import { resources } from '../../../../../resources/resources';
import { formatCode } from '../utils';

interface PreviewDialogProps {
  codes: CodeModel[];
  closeDialog: () => void;
  generateAgain: () => void;
}

export const PreviewDialog = (props: PreviewDialogProps) => {
  const { codes, closeDialog, generateAgain } = props;
  const { t: translate } = useTranslation();

  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      closeOnClickOutside
      className="dialog-merchants-edit"
    >
      <div className="dialog-content">
        <div className="dialog-title">
          {translate(resources.codes.generate.dialog.success.title)}
        </div>
        <div className="dialog-text centered mb-20">
          {translate(resources.codes.generate.dialog.success.info, {
            0: codes.length,
          })}
        </div>
        <TextArea value={codes.map(formatCode).join('\n')} readOnly rows={12} />
      </div>
      <div className="dialog-actions horizontal">
        <Button onClick={generateAgain} className="btn btn-outline">
          {translate(resources.codes.generateAgain)}
        </Button>
        <Button className="btn btn-solid" onClick={closeDialog}>
          <span className="btn-text">{translate(resources.continue)}</span>
        </Button>
      </div>
    </Dialog>
  );
};
